import React from 'react';
import {
    WidgetDate,
    WidgetTime,
    WidgetLinkTruncatedText,
    ColumnStatus,
} from '../../../../components';
import { useTranslation } from 'react-i18next';
import statuses from '../../../../constants/collections/statuses';
import CodebarModal from '../modal/CodebarModal';
import { WidgetPrice } from '../../../../components/widget/WidgetPrice';

export default function CollectionColumns () {
    const { t } = useTranslation();
    return [{
        dataField: 'id_payment',
        text: t('collections.table.columns.id'),
        sort: false,
        align: 'center',
        headerAlign: 'center',
        headerClasses: 'clientsColumnsMC_headers--title',
    },
    {
        dataField: 'payment_date',
        text: t('collections.table.columns.paymentDate'),
        headerClasses: 'clientsColumnsMC_headers--title',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: cellContent => {
            cellContent = cellContent.slice(0, -1);
            return (
                <>
                    <WidgetDate date={new Date(cellContent)} />
                    <span> </span>
                    {(cellContent ? <WidgetTime date={new Date(cellContent)} /> : null)}
                </>
            );
        }
    },
    {
        dataField: 'confirmation_code',
        text: t('collections.table.columns.code'),
        headerClasses: 'clientsColumnsMC_headers--title',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: cellContent => (cellContent ?? '-')
    },
    {
        dataField: 'informed_date',
        text: t('collections.table.columns.informedDate'),
        headerClasses: 'clientsColumnsMC_headers--title',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: cellContent => {
            cellContent = cellContent.slice(0, -1);
            return (
                <>
                    <WidgetDate date={new Date(cellContent)} />
                    <span> </span>
                    {(cellContent ? <WidgetTime date={new Date(cellContent)} /> : null)}
                </>
            );
        }
    },
    {
        dataField: 'amount',
        text: t('collections.table.columns.amount'),
        align: 'right',
        headerAlign: 'center',
        headerClasses: 'clientsColumnsMC_headers--title',
        sort: false,
        formatter: cellContent => (<WidgetPrice number={cellContent} />)
    },
    {
        dataField: 'barcode',
        text: <CodebarModal />,
        align: 'left',
        headerClasses: 'clientsColumnsMC_headers--title',
        headerAlign: 'center',
        sort: false,
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent) => (<ColumnStatus type={''} text={cellContent} />)
    },
    {
        dataField: 'document',
        text: t('collections.table.columns.document'),
        sort: false,
        align: 'left',
        headerClasses: 'clientsColumnsMC_headers--title',
        headerAlign: 'left',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row) => {
            return <WidgetLinkTruncatedText to={`/clients/details/${row.id_user || ''}`} text={cellContent || 'S/D'} truncated='false'/>;
        }
    },
    {
        dataField: 'last_four',
        text: t('collections.table.columns.lastFour'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        // eslint-disable-next-line react/display-name, react/no-multi-comp
        formatter: (cellContent, row) => (<WidgetLinkTruncatedText to={`/clients/card/${row.id_user}`} text={cellContent || '-'} truncated='false'/>)
    },
    {
        dataField: 'id_payment_status',
        text: t('collections.table.columns.status'),
        sort: false,
        headerClasses: 'clientsColumnsMC_headers--title',
        formatter: (cellContent, row) => (
            <ColumnStatus type={statuses[cellContent].type} text={t(`collections.table.status.${statuses[cellContent]?.id}`)} />
        )
    },
    ];
}
